import { ProductFeedSerializer } from "web/types/serializers";
/**
 * Extracting the product IDs of feed page array of products.
 * Returns a new array of only IDs.
 *
 * e.g. items = [
 *          {
 *              product_card :	id=899002191
 *              ...
 *              promo_label :	null
 *          },
 *          ...
 *      ]
 * becomes:
 *      ids = [ 899002191, ... ]
 *
 * @param {ProductFeedSerializer} items
 *
 * @returns {Array}
 */
export function getFeedProductIds(items: ProductFeedSerializer["feed_items"]): number[] {
    return items.map(({ product_card }) => product_card?.id);
}
